import React, { useState, useContext } from "react";

import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  TextField,
  Button,
  Container,
  IconButton,
  Typography,
  Box,
  CircularProgress,
  InputAdornment,
  Paper,
  Link,
} from "@mui/material";
import { Phone, Lock } from "@mui/icons-material";
import logo from "../assets/logos/logo.png";
import loginIcon from "../assets/icons/loginIcon.png";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const navigate = useNavigate();

  const { handleLogin, loading } = useContext(AuthContext);

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState("password");

  const validatePhone = (value) => {
    if (!value) {
      setPhoneError("Telefon numarası alanı zorunludur.");
      return false;
    }
    const isValid = /^5\d{9}$/.test(value);
    setPhoneError(
      isValid ? "" : "Geçerli bir telefon numarası girin (Örn: 5321234567)"
    );
    return isValid;
  };

  const validatePassword = (value) => {
    if (!value) {
      setPasswordError("Şifre alanı zorunludur.");
      return false;
    }
    if (value.length < 5) {
      setPasswordError("Şifre en az 5 karakter olmalıdır.");
      return false;
    }
    setPasswordError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isPhoneValid = validatePhone(phone);
    const isPasswordValid = validatePassword(password);

    if (isPhoneValid && isPasswordValid) {
      await handleLogin(phone, password);
    }
  };

  const handleSignUpClick = () => {
    navigate("/register");
  };

  const handleForgotPasswordClick = () => {
    navigate("/forgot-password");
  };

  const handleObsecureText = () => {
    setShowPassword(showPassword === "password" ? "text" : "password");
  };

  return (
    <div className="login-page-container">
      <div className="left-panel">
        <Container
          component={Paper}
          elevation={6}
          className="login-card"
          maxWidth={false}
        >
          <Box className="login-header">
            <img src={logo} alt="eKumes Logo" className="login-logo" />
          </Box>

          <Typography variant="h4" className="login-title" gutterBottom>
            Giriş Yapın
          </Typography>

          <Box component="form" onSubmit={handleSubmit} className="login-form">
            <Typography className="input-label">Telefon Numarası</Typography>
            <TextField
              fullWidth
              placeholder="5XXXXXXXXX"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
              onBlur={(e) => validatePhone(e.target.value)}
              error={!!phoneError}
              helperText={phoneError}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone className="input-icon phone-icon" />
                  </InputAdornment>
                ),
              }}
              inputProps={{ maxLength: 10 }}
              type="tel"
              className="login-input"
            />

            <Typography className="input-label" sx={{ mt: 2 }}>
              Parola
            </Typography>
            <TextField
              fullWidth
              type={showPassword}
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onBlur={(e) => validatePassword(e.target.value)}
              error={!!passwordError}
              helperText={passwordError}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock className="input-icon lock-icon" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleObsecureText}
                      edge="end"
                      className="visibility-icon"
                    >
                      <FontAwesomeIcon
                        icon={showPassword === "password" ? faEyeSlash : faEye}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              className="login-input"
            />

            <Button
              variant="contained"
              type="submit"
              disabled={loading}
              className="login-button"
              fullWidth
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "GİRİŞ YAP"
              )}
            </Button>

            <Box
              className="forgot-password-container"
              sx={{ mt: 2, textAlign: "center" }}
            >
              <Link
                component="button"
                variant="body2"
                onClick={handleForgotPasswordClick}
                className="forgot-password-link"
              >
                Şifremi Unuttum
              </Link>
            </Box>

            <Box className="signup-container">
              <Typography variant="body2" sx={{ color: "#555555" }}>
                Hesabınız yok mu?{" "}
                <Link
                  component="button"
                  variant="body2"
                  onClick={handleSignUpClick}
                  className="signup-link"
                >
                  Yeni Üyelik Oluşturun
                </Link>
              </Typography>
            </Box>
          </Box>
        </Container>
      </div>

      <div className="right-panel">
        <div className="image-frame">
          <img
            src={loginIcon}
            alt="Login Visual"
            className="side-image"
            draggable="false"
          />
          <div className="welcome-overlay">
            <Typography variant="h3" className="welcome-text">
              Hoş Geldiniz
            </Typography>
            <Typography variant="subtitle1" className="welcome-subtext">
              Kümes yönetim sistemine giriş yapın
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
